/* global Swiper */

const swiperInstances = [];

if ( typeof Swiper !== 'undefined' ) {

	document.querySelectorAll( '.b-logos-slider' ).forEach( ( block ) => {

		if ( ! block ) {

			return;

		}

		const blockSwiper = block.querySelector( '.b-logos-slider__slider.swiper' );

		if ( ! blockSwiper ) {

			return;

		}

		const directionDataset = blockSwiper.dataset?.direction;
		const sliderDirection = directionDataset !== undefined ? Boolean( parseInt( directionDataset, 10 ) ) : false;

		const swiperOptions = {
			speed: 3000,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
				reverseDirection: sliderDirection,
			},
			freeMode: true,
			slidesPerView: "auto",
			centeredSlides: true,
			spaceBetween: 24,
			loop: true,
		}

		const swiperInstance = new Swiper( blockSwiper, swiperOptions );

		if ( swiperInstance ) {

			swiperInstances.push( swiperInstance );

		}

	} );

}

window.addEventListener( 'resize', () => {

	if ( ! swiperInstances || swiperInstances.length === 0 ) {

		return;

	}

	swiperInstances.forEach( ( instance ) => {

		if ( instance && instance.initialized ) {

			instance.update();

		}

	} );

} );